import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "availability-overlay flex-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "availability-overlay__header" }, "What's your Availability?", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "availability-overlay__description" }, "This is a general setting. To block out specific days or times, use your personal calendar.", -1 /* HOISTED */)
const _hoisted_4 = { class: "availability-overlay__input slider" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "input-description-overlay" }, "Use slider to set your normal range of availability and pick the days you would like to offer to others.", -1 /* HOISTED */)
const _hoisted_6 = { class: "availability-overlay__input week" }
const _hoisted_7 = { class: "week-checkboxes" }
const _hoisted_8 = { class: "day-option" }
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "availability-overlay__exit btn-container" }
const _hoisted_11 = {
  key: 0,
  class: "loader-container flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["twoPointSlider"], {
        class: "time-slider",
        min: '5:00 am',
        max: '11:00 pm',
        minGap: .25,
        inputType: 'time',
        incrementBy: .25,
        modelValue: $setup.timeAvailability,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.timeAvailability) = $event))
      }, null, 8 /* PROPS */, ["modelValue"]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.weekSelection), (day, idx) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode($setup["checkbox"], {
              class: "checkbox",
              id: idx.toString(),
              disabled: false,
              modelValue: $setup.weekSelection[day],
              "onUpdate:modelValue": ($event: any) => (($setup.weekSelection[day]) = $event)
            }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue"]),
            _createElementVNode("label", {
              for: idx.toString()
            }, _toDisplayString(day), 9 /* TEXT, PROPS */, _hoisted_9)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", { class: "availability-overlay__confirm" }, [
      _createElementVNode("button", {
        class: "outline overlay-back",
        onClick: $setup.confirmAvailability
      }, "Update Availability")
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "borderless overlay-back",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('close')))
      }, "Back")
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode($setup["VLoader"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}